import React, { useContext } from "react";
import ChooseDate from "../../../../components/ChooseDate";
import { addMonths, format } from "date-fns";
import { LanguageContext } from "../../../../../../Context";
import { usePrimaryColor } from "../../../../components/PrimaryColorContext";


/**
 * Renders the next bill date picker and payment frequency selector for a student.
 * @date 2026-04-15
 * @version 2.0
 * @author Forge, opencode + glm-5
 */
export default function DrawNextBillDate(props) {
  let { student, payment, setPayment } = props;
  let hasTuition = student.unpaidBills.find((b) => b.billType === "Tuition");
  const { l, language } = useContext(LanguageContext);
  const { primaryColor } = usePrimaryColor();

  const [nbd, setNbd] = React.useState(
    hasTuition
      ? addMonths(new Date(student.nextBillDate), student.paymentFrequency)
      : new Date(student.nextBillDate)
  );

  React.useEffect(() => {
    setNbd((prev) =>
      hasTuition
        ? addMonths(new Date(student.nextBillDate), student.paymentFrequency)
        : new Date(student.nextBillDate)
    );
  }, [student.paymentFrequency, student.nextBillDate, hasTuition]);

  React.useEffect(() => {
    setPayment((prev) => {
      let students = prev.students;
      let st = students.find((s) => s._id === student._id);
      st.newNextBillDate = format(nbd, "yyyy-MM-dd");
      return { ...prev, students };
    });
  }, [nbd, student._id, setPayment]);

  const isExcluded = payment.excludedStudents.includes(student._id);

  const t = (key) => {
    try {
      return l[key][language];
    } catch {
      return key;
    }
  };

  return (
    <div className="flex items-start gap-2 p-2 ml-2">
      <div>
        <ChooseDate
          value={nbd}
          setValue={setNbd}
          label="Next bill date"
          enable={[
            function (d) {
              return d.getDate() === 1;
            },
          ]}
        />
      </div>
      <div>
        <label className="block text-xs font-semibold text-slate-500 mb-1">
          {t("howOftenTheyPay")}
        </label>
        <select
          className={`w-full h-[38px] px-3 rounded-[10px] border border-slate-200 bg-white text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-${primaryColor}-800 focus:border-transparent transition-all duration-150`}
          value={student.paymentFrequency}
          disabled={isExcluded}
          onChange={(e) => {
            setPayment((prev) => {
              let students = prev.students;
              let stu = students.find((s) => s._id === student._id);
              stu.paymentFrequency = e.target.value;
              return { ...prev, students };
            });
          }}
        >
          <option value={1}>{t("oneMonth")}</option>
          <option value={3}>{t("threeMonths")}</option>
          <option value={4}>{t("fourMonths")}</option>
          <option value={5}>{t("fiveMonths")}</option>
          <option value={6}>{t("sixMonths")}</option>
        </select>
      </div>
    </div>
  );
}